module.exports = __webpack_public_path__ + "img/notfound.809f7898.svg";